module.exports = __webpack_public_path__ + "static/logo-8baae21079a4db00856f794e493fcd81.svg";